import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "casanoporto_favorites_v1";
const FavoritesContext = createContext(null);

function readStorage() {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function FavoritesProvider({ children }) {
  const [slugs, setSlugs] = useState([]);

  useEffect(() => {
    setSlugs(readStorage());
    const onStorage = (e) => {
      if (e.key === KEY) setSlugs(readStorage());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const persist = (next) => {
    setSlugs(next);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
  };

  const isFavorite = useCallback((slug) => slugs.includes(slug), [slugs]);
  const toggle = useCallback((slug) => {
    if (!slug) return;
    setSlugs((current) => {
      const next = current.includes(slug) ? current.filter((s) => s !== slug) : [...current, slug];
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);
  const clear = useCallback(() => persist([]), []);

  return (
    <FavoritesContext.Provider value={{ slugs, isFavorite, toggle, clear, count: slugs.length }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  return useContext(FavoritesContext);
}
